var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhaseIcons08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#CCD1E0",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#001965"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5026 30.5664V32.502C30.5026 32.7043 30.3807 32.8867 30.1938 32.9641C30.0069 33.0416 29.7918 32.9988 29.6487 32.8557L27.3594 30.5664",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0029 21.498H30.5067C31.886 21.498 33.0042 22.6162 33.0042 23.9955V28.0685C33.0042 29.4479 31.886 30.566 30.5067 30.566V30.566",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3629 30.5657H24.4965C23.1172 30.5657 21.999 29.4475 21.999 28.0682V27",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7045 23.9998L18.351 26.3534C18.208 26.4965 17.9928 26.5392 17.8059 26.4618C17.619 26.3844 17.4971 26.202 17.4971 25.9997V23.9998H17.4936C16.8312 23.9998 16.196 23.7367 15.7276 23.2683C15.2592 22.8 14.9961 22.1647 14.9961 21.5023V17.4936C14.9961 16.1143 16.1143 14.9961 17.4936 14.9961H24.5036C25.8829 14.9961 27.0011 16.1143 27.0011 17.4936V21.5023C27.0011 22.1647 26.738 22.8 26.2696 23.2683C25.8012 23.7367 25.166 23.9998 24.5036 23.9998H20.7045Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIcons08);
export default __webpack_public_path__ + "static/media/Phase Icons 08.55ea30c27e0052dd627e35de2b5693da.svg";
export { ForwardRef as ReactComponent };